import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueCookies from "vue-cookies";
import VueWait from "vue-wait";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import Http from "@/plugins/http";
import { ValidationObserver, ValidationProvider } from "@/plugins/vee-validate";
import { i18n } from "@/plugins/i18n";
import VCalendar from "v-calendar";
import privilege from "@/plugins/privileges";
import wysiwyg from "@/plugins/quill-editor";
import CONSTANTS from "@/constants/constants";
import ROLE from "@/constants/privileges";
import toasterMixin from "@/mixins/toasterMixin";
import messageBoxMixin from "@/mixins/messageBoxMixin";
import "quill-emoji";
import "quill-emoji/dist/quill-emoji.css";
import "quill-image-compress";

// Import custon SCSS file
import "@/assets/style/main.scss";
import "@/helpers/filters";

// Install BootstrapVue
Vue.use(BootstrapVue, {
  breakpoints: [`xs`, "sm", "md", "lg", "xl", "xxl"],
});
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  locales: {
    et: {
      firstDayOfWeek: 2,
      masks: {
        input: ["MM.DD.YYYY", "YYYY-MM-DD"],
        L: "YYYY-MM-DD",
        // ...optional `title`, `weekdays`, `navMonths`, etc
      },
    },
  },
});

// Add $http directive
Vue.use(Http);

// Add $cookies
Vue.use(VueCookies);

Vue.use(require("vue-moment"));

// Add Vue await
Vue.use(VueWait);

// Add $privilege
Vue.use(privilege);
Vue.use(wysiwyg);
// inject constants to be available in templates
Vue.mixin(CONSTANTS);
Vue.mixin(ROLE);
Vue.mixin(toasterMixin);
Vue.mixin(messageBoxMixin);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  privilege,
  render: (h) => h(App),
  i18n,
  wait: new VueWait(),
}).$mount("#app");
